// extracted by mini-css-extract-plugin
export var active = "_4d-7";
export var container = "_4d-0";
export var evenWidth = "_4d-4";
export var large = "_4d-5";
export var outlet = "_4d-8";
export var slide = "_4d-2";
export var small = "_4d-6";
export var tab = "_4d-3";
export var tabs = "_4d-1";